/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Email1Inputs */

const en_common_email1 = /** @type {(inputs: Common_Email1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary Email`)
};

/**
* | output |
* | --- |
* | "Primary Email" |
*
* @param {Common_Email1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_email1 = /** @type {((inputs?: Common_Email1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Email1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_email1(inputs)
});